import styles from "./ProjectContent.module.css";

const ProjectContent = (props) => {
  const project = props.project;

  const image = require(`../../assets/images/projects/${project.id}.png`);

  const techStack = project.tech.map((item) => {
    return (
      <li key={item.id}>
        <img
          src={require(`../../assets/icons/tech/${item.id}.svg`)}
          alt={item.name}
        />
      </li>
    );
  });

  return (
    <div className={styles["project-content"]}>
      <div
        className={`${styles["description"]} ${
          props.currentState === "EXIT" && styles["description--exit"]
        }`}>
        <p className={styles["project-name"]}>
          {project.name.toUpperCase()}
          <span className={styles["shadow"]}>{project.name.toUpperCase()}</span>
        </p>
        <p className={styles["project-type"]}>{project.type}</p>
        <p className={styles["project-summary"]}>{project.summary}</p>
        <ul className={styles["tech-stack"]}>{techStack}</ul>
      </div>
      <div
        className={`${styles["image"]} ${
          props.currentState === "EXIT" && styles["image--exit"]
        }`}>
        <img src={image} alt={project.name} />
        <center>
          <a rel="noreferrer" href={project.link} target="_blank">
            View on GitHub &gt;
          </a>
        </center>
      </div>
    </div>
  );
};

export default ProjectContent;
